var map = {
	"./Community.vue": [
		"8838",
		"chunk-02b148c2"
	],
	"./Game.vue": [
		"7d36",
		"chunk-74db6e20"
	],
	"./Login.vue": [
		"a55b",
		"chunk-677cd830"
	],
	"./Main.vue": [
		"cd56",
		"chunk-0456cc88"
	],
	"./Otp.vue": [
		"125c",
		"chunk-db64aed6"
	],
	"./Pregame.vue": [
		"4a2d",
		"chunk-7f638556"
	],
	"./Profile.vue": [
		"c66d",
		"chunk-37865220"
	],
	"./UpdateProfile.vue": [
		"0af9",
		"chunk-e5c11e08"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;